"use client";

import { EXTRA_NAV_ITEMS, NAV_ITEMS, useCurrentPath } from "@/features/navigation";
import { DesktopNavbar } from "./DesktopNavbar";

export const Navbar = () => {
	const currentPath = useCurrentPath();

	return (
		<DesktopNavbar
			currentPath={currentPath}
			navItems={NAV_ITEMS}
			extraNavItems={EXTRA_NAV_ITEMS}
		/>
	);
};
